import { apiDelete, apiGet, apiPatch, apiPost } from './apiClient.js';

/**
 * Die eigenen Daten.
 *
 * Kein einziger Aufruf trägt eine Mitarbeiterkennung. Das ist nicht
 * Bequemlichkeit, sondern der Zuschnitt: der Dienst nimmt gar keine
 * entgegen - er nimmt die Personalakte, die am angemeldeten Konto hängt.
 * Damit gibt es hier keinen Aufruf, den man versehentlich auf einen Kollegen
 * richten könnte.
 *
 * Die Ausnahme sind die team-Aufrufe. Sie tragen eine fremde Kennung, weil
 * sie es müssen - aber der Dienst prüft bei jedem einzelnen, ob diese Person
 * an mich berichtet, und antwortet sonst mit 404. Sie liegen hier und nicht
 * in hrApi, weil "mein Team" meine Sicht ist: ein Vorgesetzter hat
 * typischerweise die Rolle 'employee' und käme unter /hr gar nicht erst an.
 */
export const selfApi = {
  /* .items auspacken. apiGet verpackt JEDE Antwort in { items, meta } -
     auch die, die gar keine Liste ist. Ohne das Auspacken bekam WeekGrid
     ein Objekt ohne days, und die Begrüssung auf "Meine Ferien" zeigte
     einen leeren Namen. Die Tests mockten selfApi direkt und waren
     deshalb grün, während die Seite es nicht sein konnte. */
  profile:        ()       => apiGet('/api/hr/me').then((r) => r.items),
  leaveBalances:  (params) => apiGet('/api/hr/me/leave-balances', params),
  leaveRequests:  (params) => apiGet('/api/hr/me/leave-requests', params),
  submitLeave:    (body)   => apiPost('/api/hr/me/leave-requests', body),
  /* Was kostet der Antrag, und was bleibt danach? VOR dem Absenden. */
  previewLeave:   (body)   => apiPost('/api/hr/me/leave-requests/preview', body),
  withdrawLeave:  (id)     => apiPost(`/api/hr/me/leave-requests/${id}/withdraw`, {}),
  week:           (params) => apiGet('/api/hr/me/week', params).then((r) => r.items),
  schedule:       ()       => apiGet('/api/hr/me/schedule'),
  timeEntries:    (params) => apiGet('/api/hr/me/time-entries', params),
  logTime:        (body)   => apiPost('/api/hr/me/time-entries', body),
  updateTime:     (id, body) => apiPatch(`/api/hr/me/time-entries/${id}`, body),
  /* Storno, nicht Löschen: die Zeile bleibt lesbar und fällt aus den Summen.
     Der Grund wandert mit und steht dauerhaft daran. */
  cancelTime:     (id, reason) => apiDelete(`/api/hr/me/time-entries/${id}`, { reason }),

  /* ---- Die Stempeluhr ----

     Die Uhrzeiten schickt niemand mit: Start und Stopp stempelt die
     Datenbank. Was HIER hinausgeht, ist die Zeitzone des Browsers - der
     Dienst braucht sie, um aus dem Zeitpunkt eine Wandzeit zu machen. Im
     Container laeuft die Uhr auf UTC, und aus 09:00 in Schaffhausen wuerde
     sonst 08:00.

     `.items` auspacken: apiGet verpackt JEDE Antwort in { items, meta },
     auch die, die gar keine Liste ist. */
  stempelStand:   ()      => apiGet('/api/hr/me/stempel').then((r) => r.items),
  stempelStart:   (note)  => apiPost('/api/hr/me/stempel/start', {
    zeitzone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Zurich',
    note: note || undefined,
  }),
  stempelPause:   ()      => apiPost('/api/hr/me/stempel/pause', {}),
  stempelWeiter:  ()      => apiPost('/api/hr/me/stempel/weiter', {}),
  /* `ende` nur beim vergessenen Stempel - sonst gilt der Zeitpunkt des
     Servers. */
  stempelStopp:   (body = {}) => apiPost('/api/hr/me/stempel/stopp', body),

  // ---- Der eigene Monat
  month:          (params) => apiGet('/api/hr/me/month', params).then((r) => r.items),
  months:         (params) => apiGet('/api/hr/me/months', params),
  submitMonth:    (body)   => apiPost('/api/hr/me/month/submit', body),
  withdrawMonth:  (body)   => apiPost('/api/hr/me/month/withdraw', body),

  /* Das Stundenkonto: wie viel habe ich INSGESAMT zugute? Ein einzelnes
     Objekt, deshalb .items - apiGet verpackt auch das, was keine Liste ist. */
  timeAccount:    ()       => apiGet('/api/hr/me/time-account').then((r) => r.items),

  // ---- Mein Team
  team:           ()       => apiGet('/api/hr/me/team'),
  teamRequests:   (params) => apiGet('/api/hr/me/team/leave-requests', params),
  teamOverlaps:   (id)     => apiGet(`/api/hr/me/team/leave-requests/${id}/overlaps`),
  decideRequest:  (id, body) => apiPost(`/api/hr/me/team/leave-requests/${id}/decision`, body),
  teamTimeAccounts: ()     => apiGet('/api/hr/me/team/time-accounts'),
  teamMonths:     (params) => apiGet('/api/hr/me/team/months', params),
  teamMonth:      (id, params) => apiGet(`/api/hr/me/team/months/${id}`, params).then((r) => r.items),
  teamMonthEntries: (id, params) => apiGet(`/api/hr/me/team/months/${id}/entries`, params).then((r) => r.items),
  decideMonth:    (id, body) => apiPost(`/api/hr/me/team/months/${id}/decision`, body),
};
